<template>
  <div class="i-swiper container">
    <el-carousel ref="carousel" height="240px" :interval="5000" :autoplay="true">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <el-image class="el-carousel-img" :src="item.imageUrl" @click="handleSwiper(item.href)"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    handleSwiper(url) {
      if (url) {
        setTimeout(() => window.open(url, "_blank"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.i-swiper {
  .el-carousel-img {
    width: 100%;
    height: 240px;
    cursor: pointer;
  }
}
</style>
